module.exports = __webpack_public_path__ + "img/disfruta.f5bdf8ec.png";